module.exports = __webpack_public_path__ + "img/40_69_004_690.2c12e9d2.jpg";